<template>
  <v-card flat :loading="disabled" :disabled="disabled">
    <v-card-text class="mt-1 pt-0">
      <h3 id="cast_sync_step1">取込媒体選択</h3>
      <v-subheader
        >セラピスト情報を取り込む媒体を選択してください。</v-subheader
      >
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-select
              prepend-icon="mdi-web"
              v-model="shopSiteId"
              :items="shopSites"
              item-value="id"
              item-text="name"
              no-data-text="更新管理にて媒体を登録して下さい"
              label="媒体選択"
              hide-details
              success
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <!-- 余白・インデントは取込オプション(v-expansion-panel-content)内の項目に合わせる -->
      <div class="px-6 pb-4">
        <h4>セラピスト画像の取込方法</h4>
        <p class="">
          登録されているセラピストを取込した時(更新時)、取込先媒体の画像で上書きする場合のみ、チェックをつけてください。<br /><span
            class="text-red"
            >※チェックをつけない場合、すでに画像が登録されているセラピストは媒体側の写真を取り込みません。</span
          >
        </p>
        <v-container class="">
          <v-row>
            <v-col cols="12">
              <v-checkbox
                class="mt-0"
                v-model="overwriteImage"
                label="セラピスト画像を上書きする"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <h3>取込オプション</h3>
      <v-expansion-panels flat class="mb-6">
        <v-expansion-panel>
          <v-expansion-panel-header class="pa-0">
            <v-subheader
              >媒体別に画像やコメントを取り込みたい場合に指定してください。</v-subheader
            >
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <h3>媒体個別の情報として取り込む</h3>
            <p class="">
              <span class="text-red"
                >「お店コメント・セラピストコメント」や「セラピスト画像」を、全媒体共通ではなく、媒体個別として取り込みたい時にチェックしてください。</span
              >
            </p>
            <v-container class="">
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    class="mt-0"
                    v-model="siteOnlyItems"
                    label="お店コメント・セラピストコメント"
                    value="comment"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="siteOnlyItems"
                    class="mt-0"
                    label="セラピスト画像"
                    value="image"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-container>
        <v-row>
          <v-col cols="6" sm="3">
            <general-button btn_type="gray" btn_block @click-event="onCancel"
              >キャンセル</general-button
            >
          </v-col>
          <v-col cols="6" sm="3"> </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="gray"
              btn_block
              btn_disabled
              @click-event="onBack"
              >戻る</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onNext"
              >次へ</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  reactive,
  toRefs,
  defineComponent,
  onMounted,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";

export default defineComponent({
  setup(_, ctx) {
    const ShopSitesRepository = repositoryFactory.get("shopSites");
    const state = reactive({
      shopSites: [],
      shopSiteId: 0,
      defaultShopSiteId: 0,
      disabled: false,
      siteOnlyItems: [],
      overwriteImage: false,
    });

    // 初期化処理(同期処理)
    const init = async () => {
      // ローディング表示
      store.dispatch("loadingIcon/showIcon");
      // 更新サイト一覧取得
      state.shopSites.splice(0);
      const params = new URLSearchParams();
      params.append("shop_id", store.getters["shops/currentShop"].id);
      await ShopSitesRepository.list_getcast(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              // HP連携は除外する
              if (
                response.data[key].sites_category !=
                setting.site_category_hp_link
              ) {
                if (!state.shopSiteId) {
                  // 初期値セット
                  state.shopSiteId = response.data[key].id;
                }
                // 媒体をセット
                state.shopSites.push({
                  "id": response.data[key].id,
                  "name":
                    response.data[key].sites_name +
                    (JSON.parse(response.data[key].config).memo != ""
                      ? " [ " +
                        JSON.parse(response.data[key].config).memo +
                        " ] "
                      : ""),
                });
              }
            });
          }
        })
        .catch((error) => {
          throw "ERROR:データ取得エラー (" + error + ")";
        });
      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    // 初期化する
    onMounted(async () => {
      await init();
    });

    const onCancel = () => {
      ctx.emit("click-cancel");
    };
    const onBack = () => {
      ctx.emit("click-back");
    };
    const onNext = () => {
      // 媒体が選択されていない場合はエラーを表示して中断する
      if (!state.shopSiteId) {
        alert("媒体を選択してください。");
        return;
      }
      // vuexに、選択されたshop_site_idとsite_idを記憶する
      store.dispatch("synchro_cast/setShopSiteId", state.shopSiteId);
      const site = state.shopSites.find(
        (value) => value.id == state.shopSiteId
      );
      store.dispatch("synchro_cast/setSiteId", site.site_id);
      store.dispatch("synchro_cast/setSiteOnlyItems", state.siteOnlyItems);
      store.dispatch("synchro_cast/setOverwriteImage", state.overwriteImage);
      ctx.emit("click-next");
    };

    return {
      ...toRefs(state),
      onCancel,
      onNext,
      onBack,
    };
  },
});
</script>

<style scoped>
/* h3(app.vue の .v-card__text h3)と同じマージントップに揃える */
.v-card__text h4 {
  margin-top: 1em;
}
</style>
